module.exports = __webpack_public_path__ + "img/ctrl-givens-stub-+i.61c6da3b.svg";